import { useInstanceContext, useIsVitrine } from '@/lib/use-instance';
import { vitrineMark } from '@/lib/vitrine';

/**
 * « Vitrine · v1.3.0 » in the top bar (docs/specs/vitrine.md section 7), fed by
 * `GET /api/instance`: the role says WHERE the operator is, the code says WHICH
 * version of the code runs there. A pill of the deepest blue, small enough to
 * sit beside the brand without competing with it. Nothing on the atelier, which
 * is the screen every operator already knows.
 */
export function VitrineMark() {
  const vitrine = useIsVitrine();
  const { code } = useInstanceContext();
  if (!vitrine) return null;
  return (
    <span
      data-testid="vitrine-marque"
      className="inline-flex h-5.5 items-center whitespace-nowrap rounded-full bg-bleu-nuit px-2.5 font-semibold text-caption text-white"
    >
      {vitrineMark(code)}
    </span>
  );
}
